import React from "react";
import "./styles/App.css";
import Main from "../components/Main";
import axios from "axios";
import { rootUrl } from "../config/setting";
import { Provider } from "react-redux";
import { store, persistor } from "app/store";
import { PersistGate } from "redux-persist/integration/react";
import Languages from "constants/Languages";
import TagSlugNames from "constants/TagSlugNames";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pages: [],
      menu: [],
      footer: [],
      footer2: [],
      faqpost: [],
      faqpost_zh: [],
      faqpost_en: [],
      faqpost_signup_en: [],
      faqpost_signup_zh: [],
      // blog
      tagIds: {},
      // blog page
      blogPostList: { [Languages.en]: [], [Languages.zh]: [] },
      loadBlogPostList: this.loadBlogPostList,
      pageIndex: { [Languages.en]: 1, [Languages.zh]: 1 },
      incrementPageIndex: this.incrementPageIndex,
      hasNextBlogPosts: { [Languages.en]: true, [Languages.zh]: true },
      setHasNextBlogPosts: this.setHasNextBlogPosts,
      // blog post
      blogPost: null,
      getBlogPost: this.getBlogPost,
      otherBlogPosts: [],
      getOtherBlogPostList: this.getOtherBlogPostList,
    };
  }

  getAllPages = async () => {
    let res = axios.get(rootUrl + "/wp-json/wp/v2/pages");
    let { data } = await res;
    this.setState({
      pages: data,
    });
  };
  getMenu = async () => {
    let res = axios.get(rootUrl + "/wp-json/wp/v2/menu");
    let { data } = await res;
    this.setState({
      menu: data,
    });
  };
  getFooter = async () => {
    let res = axios.get(rootUrl + "/wp-json/wp/v2/footer");
    let { data } = await res;
    this.setState({
      footer: data,
    });
  };

  getFooter2 = async () => {
    let res = axios.get(rootUrl + "/wp-json/wp/v2/footer2");
    let { data } = await res;
    this.setState({
      footer2: data,
    });
  };
  getFaq = async () => {
    // let res = axios.get(rootUrl + "/wp-json/wp/v2/faqpost");
    let res = axios.get(
      rootUrl + "/wp-json/wp/v2/faqpost?tags=10"
    );
    let { data } = await res;
    this.setState({
      faqpost: data,
    });
  };
  getFaqZh = async () => {
    let res = axios.get(
      rootUrl + "/wp-json/wp/v2/faqpost?tags=12&per_page=100"
    );
    let { data } = await res;
    this.setState({
      faqpost_zh: data,
    });
  };
  getFaqEn = async () => {
    let res = axios.get(
      rootUrl + "/wp-json/wp/v2/faqpost?tags=10&per_page=100"
    );
    let { data } = await res;
    this.setState({
      faqpost_en: data,
    });
  };
  getSignFaqEn = async () => {
    let res = axios.get(rootUrl + "/wp-json/wp/v2/faqpost?tags=11");
    let { data } = await res;
    this.setState({
      faqpost_signup_en: data,
    });
  };
  getSignFaqZh = async () => {
    let res = axios.get(rootUrl + "/wp-json/wp/v2/faqpost?tags=13");
    let { data } = await res;
    this.setState({
      faqpost_signup_zh: data,
    });
  };

  loadBlogPostList = async (language, page, tagId) => {
    let res = axios.get(
      rootUrl +
        `/wp-json/wp/v2/blogs?per_page=3&tags=${tagId}&orderby=date&page=${page}`
    );
    let { data } = await res;
    this.setState((prevState) => {
      return {
        blogPostList: {
          ...prevState.blogPostList,
          [language]: [...prevState.blogPostList[language], ...data],
        },
      };
    });
  };

  incrementPageIndex = (language) => {
    this.setState((prevState) => {
      return {
        pageIndex: {
          ...prevState.pageIndex,
          [language]: prevState.pageIndex[language] + 1,
        },
      };
    });
  };

  setHasNextBlogPosts = (language, val) => {
    this.setState((prevState) => {
      return {
        hasNextBlogPosts: { ...prevState.hasNextBlogPosts, [language]: val },
      };
    });
  };

  getBlogPost = async (language, postId, tagId) => {
    const url = rootUrl + `/wp-json/wp/v2/blogs/${postId}?tags=${tagId}`;

    const res = axios.get(url);
    const { data } = await res;
    this.setState({
      blogPost: { [language]: data },
    });
  };

  getOtherBlogPostList = async (language, postId, tagId) => {
    const url =
      rootUrl +
      `/wp-json/wp/v2/blogs?exclude=${postId}&per_page=3&tags=${tagId}&orderby=date`;
    const res = axios.get(url);
    const { data } = await res;
    this.setState({
      otherBlogPostList: { [language]: data },
    });
  };

  setTagIds = async () => {
    const res = axios.get(rootUrl + `/wp-json/wp/v2/tags`);
    const { data } = await res;
    const newTags = {};

    for (let tag of data) {
      if (tag.slug === TagSlugNames.en) {
        newTags[Languages.en] = tag.id;
      } else if (tag.slug === TagSlugNames.zh) {
        newTags[Languages.zh] = tag.id;
      }
    }
    this.setState({
      tagIds: newTags,
    });
  };

  componentDidMount = async () => {
    await this.getAllPages();
    await this.getMenu();
    await this.getFooter();
    await this.getFooter2();
    await this.getFaq();
    await this.getFaqZh();
    await this.getFaqEn();
    await this.getSignFaqEn();
    await this.getSignFaqZh();
    await this.setTagIds();
  };

  render() {
    return (
      <Provider store={store}>
        <PersistGate
          loading={<div>loading persistor</div>}
          persistor={persistor}
        >
          <Main data={this.state} />
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
